//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { useHistory, Link } from 'react-router-dom'
import styled from 'styled-components'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isNull, isUndefined, map, isEqual, reduce, find } from 'lodash'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import StringFormatter from '../../helpers/StringFormatter'
import { uriList } from '../../routings/settings/RouteList'
import { SalesHistoryByCodesStatus } from './Components'
import { salesHistoryByCodesActionCreators, itemCatalogActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseDatePicker from '../../hooks/UseDatePicker'
import Button from '../../components/Ui/Buttons'
import { TextModal, InputLogin, DatePickerFilterLabel } from '../../theme/GlobalCss'
import UseCheckAll from '../../hooks/UseCheckAll'
import urlExport from '../../constants/UrlExport'
import userPrivileges from '../../constants/PrivilegesList'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import Calendar from '../../assets/icones/global/calendar.svg'
import ViewSaleIcon from '../../assets/icones/global/view.svg'
import TrashIcon from '../../assets/icones/global/trash-blue.svg'
import PrinterIcon from '../../assets/icones/global/printer-blue.svg'
import Printer from '../../assets/icones/global/printer-white.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerTransactionIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
const CodeInput = styled.div`
	max-width: 100%;
	height: 45px;
	border: 1px solid;
	border-color: ${(props) => props.theme.colors.primary};
	margin-bottom: 5%;
	margin-top: 5%;
	color: ${(props) => props.theme.colors.menu.wrapper};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${(props) => props.theme.font.fxxxl};
	font-weight: bold;
`
const BottomWrapper = styled.div`
	max-width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`
const BottomRightWrapper = styled.div`
	max-width: 100%;
	height: 90px;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const ErrorInputMsg = styled.div`
	position: absolute;
	left: 280px;
	width: max-content;
	color: ${(props) => props.theme.colors.error};
`
const RadioContainerWrapper = styled.div`
	margin-bottom: 25px;
	width: 600px;
	height: 50px;
	display: flex;
	justify-content: center;
	alignt-items: center;
`
const WrapperRadio = styled.div`
	width: 50%;
	height: 95%;
	display: flex;
	align-items: center;
	justify-content: space-around;
`
const RadioTitle = styled.p`
	color: ${(props) => props.theme.colors.primary};
	font-size:${(props) => props.theme.font.fxs}
	width:400px;
`
const RadioInputPerimeter = styled.input`
	border: none;
	width: auto;
	height: auto;
	display: inline;
	vertical-align: baseline;
	font-size: ${(props) => props.theme.font.fm};
	color: ${(props) => props.theme.colors.primary};
`
const RadioInputLabel = styled.label`
	vertical-align: baseline;
	font-size: ${(props) => props.theme.font.fm};
`
const TextModalOr = styled.div`
	margin: 0 2%;
	padding: 15px 0;
	font-size: ${(props) => props.theme.font.fxxl};
	font-weight: bold;
`
const PrintTicketWrapper = styled(Link)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 89px;
	height: 95px;
	background-color: ${(props) => props.theme.colors.primary};
	cursor: pointer;
	border-radius: 3px;
	text-decoration: none;
`
const PrintTicketImage = styled.img`
	max-width: 38px;
	max-height: 38px;
`
const PrintTicketText = styled.p`
	font-weight: bold;
	margin: 0px;
	color: ${(props) => props.theme.colors.white};
	width: 60px;
`
const TextModalPrimary = styled.span`
	margin: 0;
	padding: 15px 0;
	font-size: 14px;
	color: ${(props) => props.theme.colors.primary};
`
const TextModalGreen = styled.span`
	margin: 0;
	padding: 15px 0;
	font-size: 14px;
	color: ${(props) => props.theme.colors.validation};
`
const TextModalSend = styled(TextModal)`
	padding: 0;
`
///////EVOL//////
const ValueWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 15px;
`
const ValueBorder = styled.div`
	height: 45px;
	width: ${(props) => (props.width ? props.width : '260px')};
	border: 3px solid ${(props) => props.borderColor};
	display: flex;
	align-items: center;
	justify-content: center;
`
const BottomLeftWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat 1fr;
	justify-content: center;
`
const BottomMiddleWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat(2, 1fr);
	grid-gap: 10px;
`
const InputLoginCustom = styled(InputLogin)`
	&::placeholder {
		text-align: center;
	}
`
//////STYLED//////

const SalesHistoryByCodes = () => {
	const {
		user,
		translations,
		salesHistoryByCodes,
		salesHistoryByCodesOptionSms,
		salesHistoryByCodesFilters,
		salesHistoryByCodesSms,
		userRolePrivileges,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			salesHistoryByCodes: state.salesHistoryByCodes,
			salesHistoryByCodesSms: state.salesHistoryByCodes.sms,
			salesHistoryByCodesOptionSms: state.salesHistoryByCodes.optionSms,
			salesHistoryByCodesFilters: state.salesHistoryByCodes.header,
			userRolePrivileges: state.user.identity.rolePrivileges,
			salesHistoryByCodesDatas: state.salesHistoryByCodes.items,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsSalesHistoryByCodes = bindActionCreators(salesHistoryByCodesActionCreators, useDispatch())
	const actionsItemCatalog = bindActionCreators(itemCatalogActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	let history = useHistory()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'saleOrder.createdDate', nameDir: 'desc' })
	const [lightSwitch, setLightSwitch] = useState(false)

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Ticket
	const [phoneNumber, setPhoneNumber] = useState()

	// Radio
	const [days, setDays] = useState(1)
	const values = ['1', '2', '3']
	const [value, setValue] = useState('1')

	// Modal
	const [row, setRow] = useState({})
	const [showModalSend, setShowModalSend] = useState(false)
	const [showModalReactive, setShowModalReactive] = useState(false)
	const [showModalCancel, setShowModalCancel] = useState(false)
	const [showModalDelete, setShowModalDelete] = useState(false)

	// Form
	const [stateDefaultValues, setStateDefaultValues] = useState()
	const { handleSubmit, errors, register } = useForm({
		defaultValues: stateDefaultValues,
	})

	// Update statuts "annulé"
	const [update, setUpdate] = useState(false)

	// Evol print / send code
	const [showGenerateModal, setShowGenerateModal] = useState(false)
	const [title, setTitle] = useState('')
	const [unActiveButton, setUnActiveButton] = useState(true)
	const [guestPhone, setGuestPhone] = useState()
	const [guestMail, setGuestMail] = useState()

	// Date picker
	const [
		dateTransactionShowModal,
		dateTransactionOpenDateModalHandler,
		dateTransactionRenderModal,
		dateTransactionStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').subtract(2, 'weeks').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate(),
	})

	//Columns
	const [columns, setColumns] = useState([])

	////////////////////////////////////////// HANDLER //////////////////////////////////////////

	const handlePagingSalesHistory = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'createdDate',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)
		actionsSalesHistoryByCodes.getHistoCode(handleFilterSend(), pg)
	}

	const handleModal = () => {
		if (showModalSend) {
			setShowModalSend(false)
		}
		if (showModalReactive) {
			setShowModalReactive(false)
		}
		if (showModalCancel) {
			setShowModalCancel(false)
		}
		if (showModalDelete) {
			setShowModalDelete(false)
		}
	}

	const handleModalReactiveCode = (row) => {
		setShowModalReactive(true)
		setRow(row)
	}

	const handleModalCancelCode = (row) => {
		setShowModalCancel(true)
		setRow(row)
	}

	const handleModalDeleteCode = (row) => {
		setShowModalDelete(true)
		setRow(row)
	}

	const handleViewTicket = (row) => {
		window.open(`${uriList.ticketCodes}/${row.salesOrderId}`, '_blank')
	}

	const handleChangeRadio = (e) => {
		setValue(e.currentTarget.value)
	}

	const handlePhoneNumber = (e) => {
		setPhoneNumber(e.target.value)
	}

	const handleReactiveCode = () => {
		actionsSalesHistoryByCodes.postRenewCode(
			{
				userKioskScope: {
					kiosksInLocalScope: reduce(
						user.identity.kioskSelected,
						(result, value) => {
							result.push(value.id)
							return result
						},
						[]
					),
				},
				durationDay: {
					durationDays: parseInt(days),
				},
			},

			row.salesOrderId
		)
		handleModal()
		setShowModalSend(true)
	}

	const handleCancelCode = () => {
		actionsSalesHistoryByCodes.postCancelSaleCode(
			{
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			row.salesOrderId
		)
		handleModal()
		setUpdate(true)
	}

	const handleDeleteCode = () => {
		actionsSalesHistoryByCodes.postDeleteSaleCode(
			{
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			row.salesOrderId
		)
		handleModal()
		setUpdate(true)
	}
	// in case of row dont have id to set inside search field we redirect like a getAll
	const handleSeeSale = (row) => {
		if (row.saleCode) {
			actionsSalesHistoryByCodes.getTransactionId(row)
			history.push(`${uriList.sales}${uriList.salesHistory}`)
		} else {
			history.push(`${uriList.sales}${uriList.salesHistory}`)
		}
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmitFilters = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'saleOrder.kiosk.labelToManufacturer', nameDir: 'desc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsSalesHistoryByCodes.getHistoCode(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }

		return {
			...filtersOut,
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			datesRange: {
				dateStart: dateTransactionStateDate.date.startDate,
				dateEnd: dateTransactionStateDate.date.endDate,
			},
		}
	}

	const handleGenerateCodeModal = () => {
		setShowGenerateModal(false)
	}
	const handleGetGuestPhone = (e) => {
		setGuestPhone(e.target.value)
	}

	const handleGetGuestMail = (e) => {
		setGuestMail(e.target.value)
	}

	const handleSendCode = (target) => {
		if (target === 'phone') {
			let bodyMsg = {
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				phoneNumber: guestPhone,
			}
			actionsItemCatalog.postSendCode(row.salesOrderId, 'sms', null, null, bodyMsg)
			setShowGenerateModal(false)
		} else if (target === 'guestMail') {
			actionsItemCatalog.postSendCode(row.salesOrderId, 'mail', 'email', guestMail)
			setShowGenerateModal(false)
		}
	}

	const handleModalSendCode = (row) => {
		setShowGenerateModal(true)
		setRow(row)
		actionsSalesHistoryByCodes.postReviewTicket(
			{
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			row.salesOrderId
		)
	}

	////////////////////////////////////////// CONFIG //////////////////////////////////////////

	useEffect(() => {
		setColumns([
			/*{ dataHook: 'id', headerName: '', "isAuthorize": false, component: SalesHistoryToggleNested, sortable: false },*/
			{
				columnReferential: 'saleByCode_creation',
				dataHook: 'creationDate',
				headerName: translations['common__admin__tableHeader_creationDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => moment(props.row.creationDate).utc().format('DD/MM/YYYY HH:mm'),
				sortableId: 'saleOrder.createdDate',
			},
			{
				columnReferential: 'saleByCode_expiration',
				dataHook: 'expirationDate',
				headerName: translations['common__admin__tableHeader_expirationDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => moment(props.row.expirationDate).utc().format('DD/MM/YYYY HH:mm'),
				sortableId: 'saleOrder.codeDateExpiration',
			},
			{
				columnReferential: 'saleByCode_useDate',
				dataHook: 'usageDate',
				headerName: translations['common__admin__tableHeader_usageDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (isNull(props.row.usageDate) ? '-' : moment(props.row.usageDate).utc().format('DD/MM/YYYY HH:mm')),
				sortableId: 'saleOrder.date',
			},
			{
				columnReferential: 'saleByCode_state',
				dataHook: 'transactionState.translationKey',
				headerName: translations['common__admin__tableHeader_transactionState'],
				sortable: true,
				isAuthorize: true,
				component: SalesHistoryByCodesStatus,
				sortableId: 'saleOrder.status.description',
			},
			{
				columnReferential: 'saleByCode_store',
				dataHook: 'store',
				headerName: translations['common__admin__tableHeader_storeLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.store.company.labelToDisplay',
			},
			{
				columnReferential: 'saleByCode_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['common__admin__tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'saleByCode_createBy',
				dataHook: 'creator',
				headerName: translations['common__admin__tableHeader_userCreated'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.usercreatedLastName',
			},
			{
				columnReferential: 'saleByCode_article',
				dataHook: 'itemLabel',
				headerName: translations['common__admin__tableHeader_itemLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemKiosk.itemDistributor.item.labelToDisplay',
			},
			{
				columnReferential: 'saleByCode_code',
				dataHook: 'saleCode',
				headerName: translations['common__admin__tableHeader_transactionCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.code',
			},
			{
				columnReferential: 'saleByCode_brand',
				dataHook: 'itemBrand.label',
				headerName: translations['common__admin__tableHeader_itemBrand'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemKiosk.itemDistributor.item.brand.label',
			},
			{
				columnReferential: 'saleByCode_family',
				dataHook: 'itemFamily.label',
				headerName: translations['common__admin__tableHeader_itemFamily'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemKiosk.itemDistributor.item.family.label',
			},
			{
				columnReferential: 'saleByCode_type',
				dataHook: 'transactionType.translationKey',
				headerName: translations['common__admin__tableHeader_transactionType'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'saleOrder.saleOrderType.label',
			},
			{
				action: true,
				isFixed: true,
				tooltipPart: 'salesByCodes',
				component: ActionsTable,
				withIcons: false,
				rest: {
					paperActionsList: [
						{
							name: translations['page__codesHistory__codesTable_modalAction_button_renewCode'],
							translationKey: 'tooltip__admin__salesByCodeHistory__tableAction__printRenew',
							clickAction: (row) => {
								handleModalReactiveCode(row)
							},
							isVisible: (row) =>
								row.canRenew === true &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[5])),
							//iconDef: PrinterIcon,
						},
						{
							name: translations['page__codesHistory__admin__modalAction_button_cancelCode'],
							translationKey: 'tooltip__admin__salesByCodeHistory__tableAction__cancelCode',
							clickAction: (row) => {
								handleModalCancelCode(row)
							},
							isVisible: (row) =>
								row.canCancel === true &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[5])),
							//iconDef: TrashIcon,
						},
						{
							name: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_modalAction_transaction'],
							translationKey: 'page__transactionsHistoryByItems__salesOrderByItemsTable_modalAction_transaction',
							clickAction: (row) => {
								handleSeeSale(row)
							},
							isVisible: () => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[13])),
							//icon: ViewSaleIcon,
						},
						{
							name: translations['page__codesHistory__admin__modalAction_button_printCode'],
							translationKey: 'tooltip__admin__salesByCodeHistory__tableAction__printResend',
							clickAction: (row) => {
								handleModalSendCode(row)
							},
							isVisible: (row) =>
								row.canResend && !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[5])),
							//icon: PrinterIcon,
						},
						{
							name: translations['page__codesHistory__admin__modalAction_button_deleteCode'],
							translationKey: 'tooltip__admin__salesByCodeHistory__tableAction__cancelCode',
							clickAction: (row) => {
								handleModalDeleteCode(row)
							},
							isVisible: (row) =>
								row.canForceDelete === true &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[5])),
							//icon: TrashIcon,
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 13,
		labelPageTable: 'saleByCode',
	}

	// Config
	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},

			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['common__fastFilter_generationDate']}
						</label>
						<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateTransactionStateDate.date.startDate, {})
									? moment(new Date()).subtract(2, 'weeks').format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateTransactionStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
		paging: {
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		},
	})
	const [configTable, setConfigTable] = useState({})

	////////////////////////////////////////// USE EFFECT //////////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsSalesHistoryByCodes.resetHistoCodeItems()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		// We make sure that we need to update => update equals true
		if (update) actionsSalesHistoryByCodes.getHistoCode(handleFilterSend(), paging)
		setUpdate(false)
	}, [update])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === salesHistoryByCodes.itemCatalog.label) return
		handleSubmitFilters()
	}, [filters.searchField])

	useEffect(() => {
		// If we came from redirection
		if (!isEmpty(salesHistoryByCodes.itemCatalog)) {
			setSearchValue(salesHistoryByCodes.itemCatalog.label)
			let filtersCP = cloneDeep(filters)
			filtersCP.searchField = salesHistoryByCodes.itemCatalog.label
			setFilters(filtersCP)
		}
	}, [salesHistoryByCodes.itemCatalog])

	useEffect(() => {
		if (dateTransactionStateDate.showModal) {
			actionsSalesHistoryByCodes.getHistoCode(handleFilterSend(), paging)
		}
	}, [dateTransactionShowModal])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)

		if (!isEmpty(salesHistoryByCodes) && !isUndefined(salesHistoryByCodes)) {
			cfg.paging = {
				totalElements: salesHistoryByCodes.paging.totalElements,
				totalPages: salesHistoryByCodes.paging.totalPages,
				fnSendTo: (paging) => handlePagingSalesHistory(paging),
			}
			setConfigTableTitle(cfg)
			//setPaging(cfg.paging)
		}
	}, [salesHistoryByCodes])

	useEffect(() => {
		setFilters(salesHistoryByCodesFilters)
		setPrevFilter(salesHistoryByCodesFilters)
	}, [translations, salesHistoryByCodesFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__codesHistory__admin__title']

		cfg.paging = {
			totalElements: salesHistoryByCodes.paging.totalElements,
			totalPages: salesHistoryByCodes.paging.totalPages,
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		}

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_brandLabel']}
					data={filters.filtersSelection?.brand.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmitFilters}
					target={'brand'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_storeLabel']}
					data={filters.filtersSelection?.store.filterElements}
					paperTopPosition={'40'}
					translations={translations}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmitFilters}
					target={'store'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_transactionState']}
					data={filters.filtersSelection?.transactionState.filterElements}
					paperTopPosition={'40'}
					translations={translations}
					toTranslate
					selectActionsHandler={handleCheckElements}
					dropColor={'blueColor'}
					submitOnClose={handleSubmitFilters}
					target={'transactionState'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_transactionType']}
					data={filters.filtersSelection?.transactionType.filterElements}
					paperTopPosition={'40'}
					translations={translations}
					selectActionsHandler={handleCheckElements}
					toTranslate
					dropColor={'blueColor'}
					submitOnClose={handleSubmitFilters}
					target={'transactionType'}
				/>
			),
		]

		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['common__fastFilter_generationDate']} :
					</label>
					<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]
		setConfigTableTitle(cfg)
	}, [translations, filters, dateTransactionStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[7],
			url: urlExport[0],
			bd: {
				filtersSelection: filters.filtersSelection,
				datesRange: { dateEnd: dateTransactionStateDate.date.endDate, dateStart: dateTransactionStateDate.date.startDate },
				searchField: searchValue,
				withFilters: true,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		setConfigTable(cfgCp)
	}, [translations, filters])
	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setLightSwitch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (lightSwitch) {
			let state_date = {
				startDate: moment().startOf('day').subtract(2, 'weeks').toDate(),
				endDate: moment().hours(23).minutes(59).toDate(),
			}

			const filtersCp = {
				withFilters: false,
				searchField: salesHistoryByCodes.itemCatalog?.label || '',
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				datesRange: {
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				searchFieldUpdated: searchValue?.length > 0 ? true : false,
			}

			actionsSalesHistoryByCodes.getHistoCode(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [lightSwitch, translations])

	useEffect(() => {
		if (row.transactionType?.label === 'Echange') {
			setTitle(translations['common__text__exchange'])
		} else {
			setTitle(translations['common__text__sale'])
		}
	}, [row])

	useEffect(() => {
		if (!isUndefined(guestPhone)) {
			if ((guestPhone?.length > 0 && salesHistoryByCodesSms !== 0) || (guestPhone?.length > 0 && salesHistoryByCodesOptionSms)) {
				setUnActiveButton(false)
			}
		}
	}, [guestPhone])

	useEffect(() => {
		if (!showGenerateModal) setGuestMail()
		setGuestPhone()
	}, [showGenerateModal])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={salesHistoryByCodes.items}
				inputConfig={configTable}
				isLoading={salesHistoryByCodes.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsSalesHistoryByCodes.getHistoCode}
			/>
		)
	}, [salesHistoryByCodes, columns, configTable, translations, paging])

	return (
		<Fragment>
			{dateTransactionRenderModal()}

			{/*MODAL REACTIVATE CODE*/}
			{showModalReactive && (
				<Modals closeModalHandler={handleModal} showModal={showModalReactive} title={translations['modal__renewCode__title']} icon={true}>
					<TextModalWrapper>
						<TextModalSend>
							{translations['modal__admin__renewCode__description_start']}{' '}
							<TextModalGreen>{row.transactionType.transactionType}</TextModalGreen>{' '}
							{translations['modal__admin__renewCode__description_end']}
						</TextModalSend>
						<TextModalSend>
							{' '}
							<TextModalPrimary>{row.itemBrand.label}</TextModalPrimary>
							{`- ${row.itemLabel}`}
						</TextModalSend>
					</TextModalWrapper>
					<CodeInput>{row.saleCode}</CodeInput>

					<RadioContainerWrapper>
						<WrapperRadio>
							<RadioTitle>{translations['modal__renewCode__expirationTime']}</RadioTitle>
						</WrapperRadio>
						<WrapperRadio>
							{map(values, (v) => (
								<RadioInputLabel>
									<RadioInputPerimeter
										type="radio"
										value={v}
										name="value"
										onChange={handleChangeRadio}
										checked={value === v}
										onClick={() => setDays(v)}
									/>
									{v === '1'
										? translations['common__text__1day']
										: v === '2'
										? translations['common__text__2days']
										: translations['common__text__3days']}
								</RadioInputLabel>
							))}
						</WrapperRadio>
					</RadioContainerWrapper>

					<ButtonWrapper>
						<Button
							actionHandler={handleModal}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>
						<Button
							actionHandler={() => handleReactiveCode()}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
						{errors?.mail && <ErrorInputMsg>{errors?.mail.message}</ErrorInputMsg>}
					</ButtonWrapper>
				</Modals>
			)}

			{/*MODAL ANNULATION CODE*/}
			{showModalCancel && (
				<Modals
					closeModalHandler={handleModal}
					showModal={showModalCancel}
					title={translations['modal__admin__cancelCode__title']}
					level="error"
					icon={true}
				>
					<CodeInput>{row.saleCode}</CodeInput>
					<TextModalWrapper>
						<TextModal>{translations['modal__admin__cancelCode__description']} </TextModal>
					</TextModalWrapper>
					<form onSubmit={handleSubmit(handleCancelCode)}>
						<ButtonWrapper>
							<Button
								actionHandler={handleModal}
								text={translations['common__text__cancel']}
								bgColor={Theme.colors.error}
								margin="true"
								img={Cancel}
							/>
							<Button
								//actionHandler={ () =>handleAnonymiseAction(rgpdData)}
								text={translations['common__text__validate']}
								bgColor={Theme.colors.validation}
								img={Validation}
							/>
							{errors?.mail && <ErrorInputMsg>{errors?.mail.message}</ErrorInputMsg>}
						</ButtonWrapper>
					</form>
				</Modals>
			)}

			{/*MODAL SUPPRESSION CODE*/}
			{showModalDelete && (
				<Modals
					closeModalHandler={handleModal}
					showModal={showModalDelete}
					title={translations['modal__admin__deleteCode__title']}
					icon={true}
					level="error"
				>
					<CodeInput>{row.saleCode}</CodeInput>
					<TextModalWrapper>
						<TextModal>{translations['modal__admin__deleteCode__description']} </TextModal>
					</TextModalWrapper>
					<form onSubmit={handleSubmit(handleDeleteCode)}>
						<ButtonWrapper>
							<Button
								actionHandler={handleModal}
								text={translations['common__text__cancel']}
								bgColor={Theme.colors.error}
								margin="true"
								img={Cancel}
							/>
							<Button
								//actionHandler={ () =>handleAnonymiseAction(rgpdData)}
								text={translations['modal__admin__deleteCode__button_delete']}
								bgColor={Theme.colors.validation}
								img={Validation}
							/>
							{errors?.mail && <ErrorInputMsg>{errors?.mail.message}</ErrorInputMsg>}
						</ButtonWrapper>
					</form>
				</Modals>
			)}

			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && <TableTitle inputConfig={configTableTitle} inputColumns={columns} />}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>

			{/*MODAL PRINT / SEND CODE*/}

			<Modals
				closeModalHandler={handleGenerateCodeModal}
				//showModal={true}
				showModal={showGenerateModal}
				title={translations['modal__admin__reprintCode__title']}
				icon={true}
				width={654}
			>
				<TextModal style={{ textAlign: 'center' }}>
					{!isUndefined(title) && `${StringFormatter.ResponseMessageParser(translations['modal__generatedCode__description'], [title])}`}
					<span style={{ color: Theme.colors.primary }}> {row?.itemBrand?.label}</span>
					<span> - </span>
					<span>{row?.itemLabel}</span>
				</TextModal>
				<ValueWrapper>
					<ValueBorder
						width={'100%'}
						style={{ fontSize: Theme.font.fxxl, color: Theme.colors.black, fontWeight: Theme.weight.bold }}
						borderColor={Theme.colors.primary}
					>
						{row?.saleCode}
					</ValueBorder>
				</ValueWrapper>
				<BottomWrapper>
					<BottomLeftWrapper>
						<PrintTicketWrapper to={`${uriList.ticketCodes}/${row?.salesOrderId}`} target={'_blank'}>
							<PrintTicketImage src={Printer} />
							<TextModal style={{ textAlign: 'center', color: Theme.colors.white, height: '36px' }} padding={'0'}>
								{translations['modal__admin__reprintCode__button_printTicket']}
							</TextModal>
						</PrintTicketWrapper>
					</BottomLeftWrapper>
					<div style={{ fontWeight: Theme.weight.bold, textAlign: 'center', fontSize: Theme.font.fxl }}>
						{translations['modal__admin__reprintCode__text_or']}
					</div>
					<BottomMiddleWrapper>
						<InputLoginCustom
							name="phone"
							type="text"
							//onFocus={handlerFocus}
							placeholder={translations['modal__admin__reprintCode__telNumber_prefilled']}
							border={Theme.colors.grey}
							onChange={handleGetGuestPhone}
						/>

						<Button
							text={
								salesHistoryByCodesSms
									? `${translations['modal__admin__reprintCode__button_sendSMS_numberLeft_start']} ${
											isUndefined(salesHistoryByCodesSms) ? '0' : `(${salesHistoryByCodesSms})`
									  } ${translations['modal__admin__reprintCode__button_sendSMS_numberLeft_end']}`
									: translations['modal__admin__reprintCode__button_sendSMS_numberLeft_start']
							}
							bgColor={Theme.colors.validation}
							height={32}
							width={208}
							radius={'3px'}
							actionHandler={() => handleSendCode('phone')}
							disabled={unActiveButton}
						/>
					</BottomMiddleWrapper>
					<div style={{ fontWeight: Theme.weight.bold, textAlign: 'center', fontSize: Theme.font.fxl, paddingLeft: '8px' }}>
						{translations['modal__admin__reprintCode__text_or']}
					</div>
					<BottomRightWrapper>
						<InputLoginCustom
							name="guestEmail"
							type="text"
							width={208}
							//onFocus={handlerFocus}
							placeholder={translations['modal__customerInfo__additionnal_info_customer_email']}
							border={Theme.colors.grey}
							ref={register({
								pattern: {
									value: RegExp(
										/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
									),
									message: translations['common__text__invalidEmail'],
								},
							})}
							onChange={handleGetGuestMail}
						/>
						{errors?.guestEmail && <ErrorInputMsg>{errors?.guestEmail.message}</ErrorInputMsg>}
						<Button
							text={translations['modal__customerInfo__additionnal_info_sendEmail']}
							bgColor={Theme.colors.validation}
							height={32}
							width={208}
							radius={'3px'}
							actionHandler={() => handleSendCode('guestMail')}
							disabled={isUndefined(guestMail) || (!isUndefined(guestMail) && !guestMail?.length > 0)}
						/>
					</BottomRightWrapper>
				</BottomWrapper>
			</Modals>
		</Fragment>
	)
}

SalesHistoryByCodes.propTypes = {}

SalesHistoryByCodes.defaultPropTypes = {}

export default SalesHistoryByCodes
